import './gascrolldepth';

const body = document.body;
const userAgent = window.navigator.userAgent;

const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
const isAndroid = /Android/i.test(userAgent);
const windowWidth = window.innerWidth;

// if we're on an iOS or Android device, or a viewport smaller than 768, use
// the simple version of the app
if (isIOS || isAndroid || windowWidth < 768) {
  require.ensure(['./simple'], (require) => {
    body.classList.add('is-simple');
    require('./simple');
  }, 'simple');
} else {
  require.ensure(['./full'], (require) => {
    body.classList.add('is-full');
    require('./full');
  }, 'full');
}

const header = document.querySelector('.header');
const scrollToContinue = document.querySelector('.scroll-to-continue');

setTimeout(() => {
  header.classList.add('visible');
}, 750);

setTimeout(() => {
  scrollToContinue.classList.add('visible');
}, 1000 * 3);

// we won't animate these things anymore, so get rid of `will-animate`
setTimeout(() => {
  header.classList.remove('will-animate');
  scrollToContinue.classList.remove('will-animate');
}, 5000);



/** WEBPACK FOOTER **
 ** ./main.js
 **/